import apiClient from './client';

// ------------------------------------------------------------------
// 五维配置 —— 人设（Persona）
// 占位模块：复用主平台端点，后续工作台任务在此之上实现 UI。
//   GET /api/v1/agents/{id}/persona
//   PUT /api/v1/agents/{id}/persona
//   GET /api/v1/persona/templates
// 主平台为 9-Section 模型（identity/mission/rules/deliverables/workflow/...），
// 字段以主平台 schemas/persona.py 的 PersonaConfig 为准，此处仅列常用字段。
// ------------------------------------------------------------------

export interface PersonaIdentity {
  role?: string;
  domain?: string;
  experience?: string;
}

export interface PersonaCommunication {
  tone?: string;
  style?: string;
  example_phrases?: string[];
}

export interface PersonaPayload {
  role?: string;
  tone?: string;
  language?: string;
  identity?: PersonaIdentity | null;
  mission?: Record<string, unknown> | null;
  rules?: string[] | string;
  deliverables?: unknown[];
  workflow?: unknown[];
  communication?: PersonaCommunication | null;
  metrics?: Record<string, unknown> | null;
  advanced_capabilities?: string[];
  emoji?: string;
  color?: string;
  vibe?: string;
  tools?: string[];
  services?: string[];
  [key: string]: unknown;
}

export interface PersonaTemplate {
  id: string;
  name: string;
  description?: string;
  category?: string;
  config?: PersonaPayload;
  payload?: Record<string, unknown>;
}

export async function getPersona(agentId: string): Promise<PersonaPayload> {
  const res = await apiClient.get<PersonaPayload>(`/agents/${agentId}/persona`);
  return res.data;
}

export async function updatePersona(agentId: string, config: PersonaPayload): Promise<PersonaPayload> {
  const res = await apiClient.put<PersonaPayload>(`/agents/${agentId}/persona`, config);
  return res.data;
}

export async function getPersonaTemplates(): Promise<PersonaTemplate[]> {
  const res = await apiClient.get<PersonaTemplate[]>('/persona/templates');
  return res.data;
}

/** 一键套用人设模板（整体替换当前人设，返回新的人设配置） */
export async function applyPersonaTemplate(
  agentId: string,
  templateId: string
): Promise<PersonaPayload> {
  const res = await apiClient.post<PersonaPayload>(`/agents/${agentId}/persona/apply-template/${templateId}`);
  return res.data;
}
